// Real-time Custom Filters JavaScript
class CustomFilters {
  constructor() {
    this.allProducts = [];
    this.totalProductCount = 0;
    this.initializeEventListeners();
    this.loadFiltersFromURL();
    this.updateAllSelectedCounts();
    this.cacheAllProducts();

    const urlParams = new URLSearchParams(window.location.search);
    const hasUrlFilters =
      urlParams.has("season") ||
      urlParams.has("scent") ||
      urlParams.has("badge") ||
      urlParams.has("size");

    if (hasUrlFilters) {
      const productGridContainer = document.getElementById(
        "ProductGridContainer"
      );
      const urlSeason = urlParams.get("season");
      const urlScent = urlParams.get("scent");
      const urlSize = urlParams.get("size");

      if (productGridContainer) {
        const containerSeason = productGridContainer.dataset.seasonFilter || "";
        const containerScent = productGridContainer.dataset.scentFilter || "";
        const containerSize = productGridContainer.dataset.sizeFilter || "";
        const filteredCount = productGridContainer.dataset.filteredCount
          ? parseInt(productGridContainer.dataset.filteredCount)
          : 0;

        const seasonMatches =
          (!urlSeason && !containerSeason) ||
          (urlSeason &&
            urlSeason.toLowerCase() === containerSeason.toLowerCase());
        const scentMatches =
          (!urlScent && !containerScent) ||
          (urlScent && urlScent.toLowerCase() === containerScent.toLowerCase());
        const sizeMatches =
          (!urlSize && !containerSize) ||
          (urlSize && urlSize.toLowerCase() === containerSize.toLowerCase());

        if (seasonMatches && scentMatches && sizeMatches && filteredCount > 0) {
          this.updateProductCount(filteredCount);
          this.updatePaginationVisibility(filteredCount);
          const productGrid = document.getElementById("product-grid");
          if (productGrid) {
            const visibleProducts = Array.from(
              productGrid.querySelectorAll("li[data-slug]")
            ).filter((item) => {
              const style = window.getComputedStyle(item);
              return (
                style.display !== "none" &&
                style.visibility !== "hidden" &&
                item.offsetParent !== null
              );
            });

            if (visibleProducts.length === filteredCount) {
              console.log(
                "Products already filtered correctly on initial load, skipping AJAX call"
              );
              return;
            }
          }
        }

        this.applyFiltersRealTime();
      } else {
        this.applyFiltersRealTime();
      }
    } else {
      this.updatePaginationVisibility(this.allProducts.length);
    }

    this.updateActivePills();
  }

  cacheAllProducts() {
    // Cache all product elements for filtering
    this.allProducts = Array.from(
      document.querySelectorAll("#product-grid > li")
    );

    // Get the actual total from the product count text, not just visible products
    const productCountElement = document.querySelector(".product-count__text");
    if (productCountElement) {
      const countMatch =
        productCountElement.textContent.match(/(\d+)\s+products?/);
      if (countMatch) {
        this.totalProductCount = parseInt(countMatch[1]);
      } else {
        this.totalProductCount = this.allProducts.length;
      }
    } else {
      this.totalProductCount = this.allProducts.length;
    }

    console.log(
      "Cached products:",
      this.allProducts.length,
      "Total products:",
      this.totalProductCount
    );

    // Apply client-side filtering if URL has filters but Liquid didn't filter
    const urlParams = new URLSearchParams(window.location.search);
    const seasonFilter = urlParams.get("season");
    const scentFilter = urlParams.get("scent");
    const badgeFilter = urlParams.get("badge");
    const sizeFilter = urlParams.get("size");
    const productGridContainer = document.getElementById(
      "ProductGridContainer"
    );
    const containerSeasonFilter =
      productGridContainer?.dataset.seasonFilter || "";

    if (
      (seasonFilter || scentFilter || badgeFilter || sizeFilter) &&
      !containerSeasonFilter
    ) {
      console.log(
        "Liquid template did not filter products, applying client-side filter"
      );
      const filteredProducts = this.allProducts.filter((productElement) => {
        return this.shouldShowProduct(
          productElement,
          scentFilter ? scentFilter.split(",") : [],
          seasonFilter ? [seasonFilter] : [],
          badgeFilter ? badgeFilter.split(",") : [],
          sizeFilter ? sizeFilter.split(",") : []
        );
      });

      this.allProducts.forEach((productElement) => {
        const shouldShow = filteredProducts.includes(productElement);
        productElement.style.display = shouldShow ? "" : "none";
      });

      const visibleCount = filteredProducts.length;
      console.log(
        `Client-side filtered initial load: ${visibleCount} products match filters (out of ${this.allProducts.length} total)`
      );
      this.updateProductCount(visibleCount);
      this.updatePaginationVisibility(visibleCount);
    }
  }

  loadFiltersFromURL() {
    const urlParams = new URLSearchParams(window.location.search);

    // Load scent filters
    const scents = urlParams.get("scent");
    if (scents) {
      const scentValues = scents.split(",");
      scentValues.forEach((scent) => {
        const input = document.querySelector(
          `input[name="scent"][value="${scent}"]`
        );
        if (input) {
          input.checked = true;
        }
      });
    }

    // Load season filters
    const season = urlParams.get("season");
    if (season) {
      const input = document.querySelector(
        `input[name="season"][value="${season}"]`
      );
      if (input) {
        input.checked = true;
      }
    }

    // Load badge filters
    const badges = urlParams.get("badge");
    if (badges) {
      const badgeValues = badges.split(",");
      badgeValues.forEach((badge) => {
        const input = document.querySelector(
          `input[name="badge"][value="${badge}"]`
        );
        if (input) {
          input.checked = true;
        }
      });
    }

    const sizes = urlParams.get("size");
    if (sizes) {
      sizes.split(",").forEach((size) => {
        const input = document.querySelector(
          `input[name="size"][value="${size}"]`
        );
        if (input) {
          input.checked = true;
        }
      });
    }
  }

  updateURL() {
    const scentInputs = document.querySelectorAll(
      'input[name="scent"]:checked'
    );
    const seasonInputs = document.querySelectorAll(
      'input[name="season"]:checked'
    );
    const badgeInputs = document.querySelectorAll(
      'input[name="badge"]:checked'
    );
    const sizeInputs = document.querySelectorAll(
      'input[name="size"]:checked'
    );

    const selectedScents = Array.from(scentInputs).map((input) => input.value);
    const selectedSeasons = Array.from(seasonInputs).map(
      (input) => input.value
    );
    const selectedBadges = Array.from(badgeInputs).map((input) => input.value);
    const selectedSizes = Array.from(sizeInputs).map((input) => input.value);

    const urlParams = new URLSearchParams(window.location.search);

    // Update scent parameter
    if (selectedScents.length > 0) {
      urlParams.set("scent", selectedScents.join(","));
    } else {
      urlParams.delete("scent");
    }

    // Update season parameter
    if (selectedSeasons.length > 0) {
      urlParams.set("season", selectedSeasons.join(","));
    } else {
      urlParams.delete("season");
    }

    // Update badge parameter
    if (selectedBadges.length > 0) {
      urlParams.set("badge", selectedBadges.join(","));
    } else {
      urlParams.delete("badge");
    }

    if (selectedSizes.length > 0) {
      urlParams.set("size", selectedSizes.join(","));
    } else {
      urlParams.delete("size");
    }

    // Update URL without page refresh
    const newURL = urlParams.toString()
      ? `${window.location.pathname}?${urlParams.toString()}`
      : window.location.pathname;

    window.history.pushState({}, "", newURL);
  }

  initializeEventListeners() {
    // Filter dropdown changes
    document.addEventListener("change", (event) => {
      if (
        event.target.matches(
          'input[name="scent"], input[name="season"], input[name="badge"], input[name="size"]'
        )
      ) {
        console.log(
          "Filter changed:",
          event.target.name,
          event.target.value,
          event.target.checked
        );
        this.handleFilterChange(event);
      }
    });

    // Reset buttons and remove filter pills
    document.addEventListener("click", (event) => {
      if (event.target.matches(".facets-dropdown__reset")) {
        event.preventDefault();
        console.log("Reset clicked for:", event.target.dataset.filter);
        this.handleReset(event);
      }

      // Handle clicks on filter remove buttons (including clicks on the X icon)
      const removeButton = event.target.closest(".custom-filter-remove");
      if (removeButton) {
        event.preventDefault();
        console.log(
          "Remove filter clicked:",
          removeButton.dataset.filterType,
          removeButton.dataset.filterValue
        );
        this.handleRemoveFilter({ currentTarget: removeButton });
      }
    });

    // Update selected counts when dropdowns open/close
    document.addEventListener("toggle", (event) => {
      if (event.target.matches(".facets-dropdown")) {
        console.log(
          "Dropdown toggled:",
          event.target.id,
          "open:",
          event.target.open
        );
        this.updateSelectedCount(event.target);

        // Close other dropdowns when one opens
        if (event.target.open) {
          document.querySelectorAll(".facets-dropdown").forEach((dropdown) => {
            if (dropdown !== event.target && dropdown.open) {
              console.log("Closing other dropdown:", dropdown.id);
              dropdown.open = false;
            }
          });
        }
      }
    });

    // Close dropdowns when clicking outside
    document.addEventListener("click", (event) => {
      const clickedDropdown = event.target.closest(".facets-dropdown");

      if (!clickedDropdown) {
        // Clicked outside all dropdowns - close any open ones
        document
          .querySelectorAll(".facets-dropdown[open]")
          .forEach((dropdown) => {
            console.log("Closing dropdown from outside click:", dropdown.id);
            dropdown.open = false;
          });
      }
    });
  }

  async handleFilterChange(event) {
    // Update the count immediately
    const dropdown = event.target.closest(".facets-dropdown");
    this.updateSelectedCount(dropdown);

    // Update URL first so applyFiltersRealTime can read the correct state
    this.updateURL();
    // Apply filters in real-time
    await this.applyFiltersRealTime();
    this.updateActivePills();
  }

  async handleReset(event) {
    const filterType = event.target.dataset.filter;
    const dropdown = event.target.closest(".facets-dropdown");

    // Uncheck all inputs of this type
    dropdown
      .querySelectorAll(`input[name="${filterType}"]`)
      .forEach((input) => {
        input.checked = false;
      });

    this.updateSelectedCount(dropdown);
    this.updateURL();
    await this.applyFiltersRealTime();
    this.updateActivePills();
  }

  async handleRemoveFilter(event) {
    const filterType = event.currentTarget.dataset.filterType;
    const filterValue = event.currentTarget.dataset.filterValue;

    // Find and uncheck the specific input
    const inputs = document.querySelectorAll(
      `input[name="${filterType}"][value="${filterValue}"]`
    );
    inputs.forEach((input) => {
      input.checked = false;
    });

    // Update the dropdown count
    const dropdown = document.getElementById(`${filterType}-dropdown`);
    if (dropdown) {
      this.updateSelectedCount(dropdown);
    }

    this.updateURL();
    await this.applyFiltersRealTime();
    this.updateActivePills();
  }

  updateSelectedCount(dropdown) {
    if (!dropdown) return;

    const selectedSpan = dropdown.querySelector(".facets-dropdown__selected");
    const inputs = dropdown.querySelectorAll("input:checked");
    const count = inputs.length;

    if (selectedSpan) {
      selectedSpan.textContent =
        count === 0 ? "0 selected" : `${count} selected`;
    }
  }

  updateAllSelectedCounts() {
    document.querySelectorAll(".facets-dropdown").forEach((dropdown) => {
      this.updateSelectedCount(dropdown);
    });
  }

  async fetchAllFilteredProducts(
    sectionId,
    selectedScents,
    selectedSeasons,
    selectedBadges,
    selectedSizes,
    sortBy
  ) {
    const allProducts = [];
    let page = 1;
    let hasMorePages = true;
    // Learned from the first response rather than assumed. Liquid's `paginate` is driven by
    // the section's own products_per_page setting and ignores a `limit` query param, so
    // hardcoding a guess here meant page one came back a different length than expected,
    // the loop decided there was nothing more to fetch, and every product past the first
    // page was silently missing from every filter result.
    let productsPerPage = null;

    while (hasMorePages) {
      const searchParams = new URLSearchParams();
      searchParams.set("section_id", sectionId);
      searchParams.set("page", page.toString());

      if (selectedScents.length > 0) {
        searchParams.set("scent", selectedScents.join(","));
      }
      if (selectedSeasons.length > 0) {
        searchParams.set("season", selectedSeasons[0]);
      }
      if (selectedBadges.length > 0) {
        searchParams.set("badge", selectedBadges.join(","));
      }
      if (selectedSizes.length > 0) {
        searchParams.set("size", selectedSizes.join(","));
      }
      if (sortBy) {
        searchParams.set("sort_by", sortBy);
      }

      const url = `${window.location.pathname}?${searchParams.toString()}`;
      console.log(`Fetching page ${page} from:`, url);

      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const productGrid = doc.getElementById("product-grid");

        if (productGrid) {
          const pageProducts = Array.from(productGrid.querySelectorAll("li"));
          if (pageProducts.length === 0) {
            hasMorePages = false;
          } else {
            if (productsPerPage === null) {
              productsPerPage = pageProducts.length;
            }
            allProducts.push(...pageProducts);
            // A short page is the last one; a full page means there may be another.
            hasMorePages = pageProducts.length === productsPerPage;
            page++;
          }
        } else {
          hasMorePages = false;
        }
      } catch (error) {
        console.error(`Error fetching page ${page}:`, error);
        hasMorePages = false;
      }
    }

    return allProducts;
  }

  async applyFiltersRealTime() {
    const urlParams = new URLSearchParams(window.location.search);

    const scentInputs = document.querySelectorAll(
      'input[name="scent"]:checked'
    );
    const seasonInputs = document.querySelectorAll(
      'input[name="season"]:checked'
    );
    const badgeInputs = document.querySelectorAll(
      'input[name="badge"]:checked'
    );
    const sizeInputs = document.querySelectorAll(
      'input[name="size"]:checked'
    );

    let selectedScents = Array.from(scentInputs).map((input) => input.value);
    let selectedSeasons = Array.from(seasonInputs).map((input) => input.value);
    let selectedBadges = Array.from(badgeInputs).map((input) => input.value);
    let selectedSizes = Array.from(sizeInputs).map((input) => input.value);

    if (selectedScents.length === 0 && urlParams.has("scent")) {
      selectedScents = urlParams.get("scent").split(",");
    }

    if (selectedSeasons.length === 0 && urlParams.has("season")) {
      selectedSeasons = [urlParams.get("season")];
    }

    if (selectedBadges.length === 0 && urlParams.has("badge")) {
      selectedBadges = urlParams.get("badge").split(",");
    }

    if (selectedSizes.length === 0 && urlParams.has("size")) {
      selectedSizes = urlParams.get("size").split(",");
    }

    console.log("Applying filters:", {
      selectedScents,
      selectedSeasons,
      selectedBadges,
      selectedSizes,
    });

    const productGrid = document.getElementById("product-grid");
    if (!productGrid) {
      console.warn("Product grid not found");
      return;
    }

    const sectionId = productGrid.dataset.id;
    if (!sectionId) {
      console.warn("Section ID not found");
      return;
    }

    const productGridContainer = document.getElementById(
      "ProductGridContainer"
    );
    if (!productGridContainer) {
      console.warn("Product grid container not found");
      return;
    }

    productGridContainer.querySelector(".collection")?.classList.add("loading");

    const currentUrlParams = new URLSearchParams(window.location.search);
    const sortBy = currentUrlParams.get("sort_by");

    try {
      let allProductElements = [];

      console.log("Fetching all products across all pages...");
      allProductElements = await this.fetchAllFilteredProducts(
        sectionId,
        selectedScents,
        selectedSeasons,
        selectedBadges,
        selectedSizes,
        sortBy
      );
      console.log(
        `Fetched ${allProductElements.length} products from all pages`
      );

      if (allProductElements.length > 0) {
        const productGrid = document.getElementById("product-grid");
        if (productGrid) {
          productGrid.innerHTML = "";
          allProductElements.forEach((element) => {
            productGrid.appendChild(element);
          });
        }

        this.allProducts = allProductElements;

        let finalProductCount;

        if (
          selectedScents.length > 0 ||
          selectedSeasons.length > 0 ||
          selectedBadges.length > 0 ||
          selectedSizes.length > 0
        ) {
          const filteredProducts = this.allProducts.filter((productElement) => {
            return this.shouldShowProduct(
              productElement,
              selectedScents,
              selectedSeasons,
              selectedBadges,
              selectedSizes
            );
          });

          this.allProducts.forEach((productElement) => {
            const shouldShow = filteredProducts.includes(productElement);
            productElement.style.display = shouldShow ? "" : "none";
          });

          finalProductCount = filteredProducts.length;
          console.log(
            `Client-side filtered: ${finalProductCount} products match filters (out of ${this.allProducts.length} total fetched)`
          );
          this.updateProductCount(finalProductCount);
          this.updatePaginationVisibility(finalProductCount);
        } else {
          finalProductCount = this.allProducts.length;
          console.log(`Loaded ${finalProductCount} products`);
          this.updateProductCount(finalProductCount);
          this.updatePaginationVisibility(finalProductCount);
        }

        this.updatePaginationUrls();

        if (typeof initializeScrollAnimationTrigger === "function") {
          initializeScrollAnimationTrigger(productGridContainer);
        }

        console.log(`Loaded ${finalProductCount} filtered products`);

        if (typeof window.logCollectionProducts === "function") {
          setTimeout(() => {
            window.logCollectionProducts();
          }, 100);
        }
      }

      productGridContainer
        .querySelector(".collection")
        ?.classList.remove("loading");
    } catch (error) {
      console.error("Error fetching filtered products:", error);
      productGridContainer
        .querySelector(".collection")
        ?.classList.remove("loading");
    }
  }

  shouldShowProduct(
    productElement,
    selectedScents,
    selectedSeasons,
    selectedBadges = [],
    selectedSizes = []
  ) {
    // Get product data from the element
    const productData = this.getProductData(productElement);

    // Check scent filter
    if (selectedScents.length > 0) {
      const hasMatchingScent = selectedScents.some((selectedScent) =>
        productData.scents.includes(selectedScent)
      );
      if (!hasMatchingScent) {
        return false;
      }
    }

    // Check season filter - check both tags and seasons data attribute
    if (selectedSeasons.length > 0) {
      const productTags = productElement.dataset.tags
        ? productElement.dataset.tags
            .split(",")
            .map((t) => t.trim().toLowerCase())
        : [];
      const productSeasons = productData.seasons.map((s) => s.toLowerCase());

      const hasMatchingSeason = selectedSeasons.some((selectedSeason) => {
        const seasonLower = selectedSeason.toLowerCase();
        // Check if product has the season tag
        const hasTag = productTags.some((tag) => tag === seasonLower);
        // Check if product has the season in seasons data attribute
        const hasSeasonData = productSeasons.includes(seasonLower);
        return hasTag || hasSeasonData;
      });

      if (!hasMatchingSeason) {
        return false;
      }
    }

    // Check badge filter
    if (selectedBadges.length > 0) {
      const productBadge = productElement.dataset.badge
        ? productElement.dataset.badge.toLowerCase()
        : "";
      const hasMatchingBadge = selectedBadges.some((selectedBadge) => {
        const badgeLower = selectedBadge.toLowerCase();
        return productBadge === badgeLower;
      });

      if (!hasMatchingBadge) {
        return false;
      }
    }

    if (selectedSizes.length > 0) {
      const productTags = productElement.dataset.tags
        ? productElement.dataset.tags
            .split(",")
            .map((tag) => tag.trim().toLowerCase())
        : [];
      if (
        !selectedSizes.some((size) =>
          productTags.includes(size.toLowerCase())
        )
      ) {
        return false;
      }
    }

    return true;
  }

  getProductData(productElement) {
    // Extract product data from data attributes or content
    const productData = {
      scents: [],
      seasons: [],
      badge: "",
    };

    // Try to get data from data attributes first
    if (productElement.dataset.scents) {
      productData.scents = productElement.dataset.scents.split(",");
    }
    if (productElement.dataset.seasons) {
      productData.seasons = productElement.dataset.seasons.split(",");
    }
    if (productElement.dataset.badge) {
      productData.badge = productElement.dataset.badge;
    }

    return productData;
  }

  updateProductCount(count) {
    const countElements = document.querySelectorAll(".product-count__text");
    countElements.forEach((element) => {
      element.textContent = `${count} products`;
    });

    // Update mobile toggle button count
    const mobileToggleCount = document.querySelector(
      ".mobile-filter-toggle__count"
    );
    if (mobileToggleCount) {
      mobileToggleCount.textContent = `${count} products`;
    }
  }

  hasActiveFilters() {
    const scentInputs = document.querySelectorAll(
      'input[name="scent"]:checked'
    );
    const seasonInputs = document.querySelectorAll(
      'input[name="season"]:checked'
    );
    const badgeInputs = document.querySelectorAll(
      'input[name="badge"]:checked'
    );
    const sizeInputs = document.querySelectorAll(
      'input[name="size"]:checked'
    );
    return (
      scentInputs.length > 0 ||
      seasonInputs.length > 0 ||
      badgeInputs.length > 0 ||
      sizeInputs.length > 0
    );
  }

  updatePaginationVisibility(visibleCount) {
    const productsPerPage = 48;
    const paginationElements = document.querySelectorAll(
      '.pagination-wrapper, .pagination, nav[aria-label*="Pagination"], nav[role="navigation"][aria-label*="pagination"]'
    );

    if (this.hasActiveFilters()) {
      const shouldHidePagination = visibleCount <= productsPerPage;
      paginationElements.forEach((pagination) => {
        pagination.style.display = shouldHidePagination ? "none" : "";
      });
    } else {
      paginationElements.forEach((pagination) => {
        pagination.style.display = "";
      });
    }
  }

  // Mobile sidebar methods
  openMobileSidebar() {
    document.body.classList.add("mobile-sidebar-open");
    const sidebar = document.querySelector(".mobile-filter-sidebar");
    const overlay = document.querySelector(".mobile-filter-sidebar-overlay");

    if (sidebar) sidebar.classList.add("mobile-filter-sidebar--open");
    if (overlay) overlay.classList.add("mobile-filter-sidebar-overlay--open");
  }

  closeMobileSidebar() {
    document.body.classList.remove("mobile-sidebar-open");
    const sidebar = document.querySelector(".mobile-filter-sidebar");
    const overlay = document.querySelector(".mobile-filter-sidebar-overlay");

    if (sidebar) sidebar.classList.remove("mobile-filter-sidebar--open");
    if (overlay)
      overlay.classList.remove("mobile-filter-sidebar-overlay--open");
  }

  updateActivePills() {
    const scentInputs = document.querySelectorAll(
      'input[name="scent"]:checked'
    );
    const seasonInputs = document.querySelectorAll(
      'input[name="season"]:checked'
    );
    const badgeInputs = document.querySelectorAll(
      'input[name="badge"]:checked'
    );
    const sizeInputs = document.querySelectorAll(
      'input[name="size"]:checked'
    );

    const selectedScents = Array.from(scentInputs).map((input) => ({
      value: input.value,
      label: input.dataset.scent || input.value,
    }));
    const selectedSeasons = Array.from(seasonInputs).map((input) => ({
      value: input.value,
      label: input.dataset.season || input.value,
    }));
    const selectedBadges = Array.from(badgeInputs).map((input) => ({
      value: input.value,
      label: input.dataset.badge || input.value,
    }));
    const selectedSizes = Array.from(sizeInputs).map((input) => ({
      value: input.value,
      label: input.dataset.size || input.value,
    }));

    // Update active pills
    const activeFacetsContainer = document.querySelector(".active-facets");
    if (!activeFacetsContainer) return;

    let pillsHTML = "";

    selectedScents.forEach((scent) => {
      pillsHTML += `
        <a href="#" class="active-facets__button custom-filter-remove" data-filter-type="scent" data-filter-value="${scent.value}">
          <span class="active-facets__button-inner">
            Scent: ${scent.label}
            <svg width="1rem" height="1rem" viewBox="0 0 10 10" fill="none">
              <path d="M2 2L8 8M8 2L2 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </span>
        </a>
      `;
    });

    selectedSeasons.forEach((season) => {
      pillsHTML += `
        <a href="#" class="active-facets__button custom-filter-remove" data-filter-type="season" data-filter-value="${season.value}">
          <span class="active-facets__button-inner">
            Season: ${season.label}
            <svg width="1rem" height="1rem" viewBox="0 0 10 10" fill="none">
              <path d="M2 2L8 8M8 2L2 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </span>
        </a>
      `;
    });

    selectedBadges.forEach((badge) => {
      pillsHTML += `
        <a href="#" class="active-facets__button custom-filter-remove" data-filter-type="badge" data-filter-value="${badge.value}">
          <span class="active-facets__button-inner">
            Highlights: ${badge.label}
            <svg width="1rem" height="1rem" viewBox="0 0 10 10" fill="none">
              <path d="M2 2L8 8M8 2L2 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </span>
        </a>
      `;
    });

    selectedSizes.forEach((size) => {
      pillsHTML += `
        <a href="#" class="active-facets__button custom-filter-remove" data-filter-type="size" data-filter-value="${size.value}">
          <span class="active-facets__button-inner">
            Candle Size: ${size.label}
            <svg width="1rem" height="1rem" viewBox="0 0 10 10" fill="none">
              <path d="M2 2L8 8M8 2L2 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </span>
        </a>
      `;
    });

    if (
      selectedScents.length > 0 ||
      selectedSeasons.length > 0 ||
      selectedBadges.length > 0 ||
      selectedSizes.length > 0
    ) {
      /*  pillsHTML += `
        <a href="#" class="active-facets__button-remove" onclick="window.customFilters.clearAllFilters(); return false;">
          <span>Clear all</span>
        </a>
      `; */
      activeFacetsContainer.innerHTML = pillsHTML;
      activeFacetsContainer.style.display = "flex";
    } else {
      activeFacetsContainer.style.display = "none";
    }
  }

  async clearAllFilters() {
    // Uncheck all filter inputs
    document
      .querySelectorAll(
        'input[name="scent"], input[name="season"], input[name="badge"], input[name="size"]'
      )
      .forEach((input) => {
        input.checked = false;
      });

    // Update counts
    this.updateAllSelectedCounts();

    // Update URL before fetching unfiltered section
    this.updateURL();
    await this.applyFiltersRealTime();

    // Update pills
    this.updateActivePills();
  }

  updatePaginationUrls() {
    const scentInputs = document.querySelectorAll(
      'input[name="scent"]:checked'
    );
    const seasonInputs = document.querySelectorAll(
      'input[name="season"]:checked'
    );
    const badgeInputs = document.querySelectorAll(
      'input[name="badge"]:checked'
    );
    const sizeInputs = document.querySelectorAll(
      'input[name="size"]:checked'
    );

    const selectedScents = Array.from(scentInputs).map((input) => input.value);
    const selectedSeasons = Array.from(seasonInputs).map(
      (input) => input.value
    );
    const selectedBadges = Array.from(badgeInputs).map((input) => input.value);
    const selectedSizes = Array.from(sizeInputs).map((input) => input.value);

    const paginationLinks = document.querySelectorAll(
      ".pagination__item[href]"
    );
    paginationLinks.forEach((link) => {
      const href = link.getAttribute("href");
      if (!href) return;

      try {
        const url = new URL(href, window.location.origin);
        if (selectedScents.length > 0) {
          url.searchParams.set("scent", selectedScents.join(","));
        } else {
          url.searchParams.delete("scent");
        }

        if (selectedSeasons.length > 0) {
          url.searchParams.set("season", selectedSeasons[0]);
        } else {
          url.searchParams.delete("season");
        }

        if (selectedBadges.length > 0) {
          url.searchParams.set("badge", selectedBadges.join(","));
        } else {
          url.searchParams.delete("badge");
        }

        if (selectedSizes.length > 0) {
          url.searchParams.set("size", selectedSizes.join(","));
        } else {
          url.searchParams.delete("size");
        }

        link.setAttribute("href", url.pathname + url.search);
      } catch (e) {
        console.warn("Error updating pagination URL:", e);
      }
    });
  }

  handleSortChange(sortValue) {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set("sort_by", sortValue);

    const newURL = `${window.location.pathname}?${urlParams.toString()}`;
    window.location.href = newURL;
  }
}

// Initialize when DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  console.log("Initializing real-time custom filters...");

  // Check if we have filter dropdowns
  const dropdowns = document.querySelectorAll(".facets-dropdown");
  console.log("Found dropdowns:", dropdowns.length);

  if (dropdowns.length > 0) {
    // Initialize the custom filters
    window.customFilters = new CustomFilters();
    console.log("Real-time custom filters initialized");
  } else {
    console.log("No filter dropdowns found");
  }
});
